import { newRelicJSError } from '@nmx/utils/dist/utilities/frontend/Analytics/new_relic_helper';

// this function requires this: <script async src="https://www.googletagmanager.com/gtag/js?id={{@root.googleAdWordsId}}"></script>
// Event snippet for Pre-Client: Lead Form Submission conversion page
// eslint-disable-next-line import/prefer-default-export
export function googleTagManagerTrackLead() {
  try {
    window.gtag('event',
      'conversion', { send_to: '<%=googleAdWordsId%>/EfPFCL-7wW4QgdSD5QM' });
  } catch (err) {
    const error = `Error tracking lead form submission for Google Pixel: ${err}`;
    newRelicJSError(error);
    console.error(error);
  }
}

